import { initializeConsent } from './utils/consent';
import { startAcquisitionCapture } from './utils/acquisition';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { theme } from './theme';
import App from './App';
import { clearChunkReloadQueryParam } from './utils/lazyWithChunkReload';
import { initErrorReporting } from './utils/errorReporting';
import { injectBBTokens } from './styles/bbTokens';
import './styles/wizard.css';

initErrorReporting();
injectBBTokens();

// Validate Supabase environment variables
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error("Missing Supabase environment variables. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY");
}

clearChunkReloadQueryParam();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: unknown) => {
        // Don't retry on 401/403 errors (auth issues)
        const err = error as { response?: { status?: number } };
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          return false;
        }
        return failureCount < 2;
      },
    },
  },
});

// Note: Axios interceptors are now automatically set up in axiosConfig.ts
// No need for a wrapper component since we use auth state listeners

initializeConsent();
startAcquisitionCapture();
window.addEventListener('storage', initializeConsent);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
